export function PauseExchangeIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M13.2812 8C13.2812 6.59933 12.7248 5.25602 11.7344 4.26559C10.744 3.27517 9.40067 2.71875 8 2.71875C6.59933 2.71875 5.25602 3.27517 4.26559 4.26559C3.27517 5.25602 2.71875 6.59933 2.71875 8C2.71875 9.40067 3.27517 10.744 4.26559 11.7344C5.25602 12.7248 6.59933 13.2812 8 13.2812C9.40067 13.2812 10.744 12.7248 11.7344 11.7344C12.7248 10.744 13.2812 9.40067 13.2812 8ZM1.5 8C1.5 6.27609 2.18482 4.62279 3.40381 3.40381C4.62279 2.18482 6.27609 1.5 8 1.5C9.72391 1.5 11.3772 2.18482 12.5962 3.40381C13.8152 4.62279 14.5 6.27609 14.5 8C14.5 9.72391 13.8152 11.3772 12.5962 12.5962C11.3772 13.8152 9.72391 14.5 8 14.5C6.27609 14.5 4.62279 13.8152 3.40381 12.5962C2.18482 11.3772 1.5 9.72391 1.5 8ZM7.1875 6.17188V9.82812C7.1875 10.1658 6.91582 10.4375 6.57812 10.4375C6.24043 10.4375 5.96875 10.1658 5.96875 9.82812V6.17188C5.96875 5.83418 6.24043 5.5625 6.57812 5.5625C6.91582 5.5625 7.1875 5.83418 7.1875 6.17188ZM10.0312 6.17188V9.82812C10.0312 10.1658 9.75957 10.4375 9.42188 10.4375C9.08418 10.4375 8.8125 10.1658 8.8125 9.82812V6.17188C8.8125 5.83418 9.08418 5.5625 9.42188 5.5625C9.75957 5.5625 10.0312 5.83418 10.0312 6.17188Z"
        fill="var(--foreground-default, #101010)"
      />
    </svg>
  );
}
